import * as React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import HomeIcon from '@material-ui/icons/Home';
import ResumeIcon from '@material-ui/icons/Description';
import { Link } from 'react-router-dom';
import { ISlider } from 'types/Navigation/NavigationStructure';
import { useStyles } from './styles';

export const mainListItems = (
  <div>
    <ListItem button component={Link} to="/inicio">
      <ListItemIcon>
        <HomeIcon />
      </ListItemIcon>
      <ListItemText primary="Inicio" />
    </ListItem>
    <ListItem button component={Link} to="/resumen-oportunidades">
      <ListItemIcon>
        <ResumeIcon />
      </ListItemIcon>
      <ListItemText primary="Resumen de oportunidades" />
    </ListItem>
  </div>
);

const DrawerList: React.FC<ISlider> = ({ link, label, icon }) => {
  const classes = useStyles();

  return (
    <div>
      <ListItem button component={Link} to={link} className={classes.itemList}>
        <ListItemIcon className={classes.itemIcon}>{icon}</ListItemIcon>
        <ListItemText primaryTypographyProps={{ className: classes.itemText }} primary={label} />
      </ListItem>
    </div>
  );
};

export default DrawerList;
